var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"green-lighter green-section w-full"},[_c('div',{staticClass:"section section--lg"},[_vm._t("default"),(_vm.$slots.form)?_c('div',{staticClass:"green-section__form"},[_vm._t("form")],2):_vm._e()],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }